import PropTypes from 'prop-types';
import Slider from 'rc-slider';

const Handle = Slider.Handle;

SliderHandle.propTypes = {
  value: PropTypes.number.isRequired,
  dragging: PropTypes.bool,
  index: PropTypes.number,
};

export default function SliderHandle({value, dragging, index, ...restProps}) {
  const floater = value / 10;
  return (
    <Handle value={value} {...restProps}>
      {floater.toPrecision(2)}
    </Handle>
  );
}
